<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2 v-if="actionType === 'create'">Criar operação</h2>
          <h2 v-if="actionType === 'update'">Editar operação</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="8">
          <h3>Tipo</h3>
          <p>O tipo <code>evento</code> exibe qrcode para validação. O tipo <code>ficha</code> não.</p>
          <b-form-group>
            <b-form-radio v-model="form.show_qrcode" :value="true">Evento</b-form-radio>
            <b-form-radio v-model="form.show_qrcode" :value="false">Ficha</b-form-radio>
          </b-form-group>

          <hr>

          <h3>Logo</h3>

          <b-button class="mr-1 mb-1" v-b-modal.send-logo>
            <icon name="image" scale="1" class="mr-2"></icon> Enviar logo
          </b-button>

          <hr>

          <h3>Dados da operação</h3>

          <b-form-group
            label="Nome da operação:"
            description="Exemplo: Entrosa Bixo 2018">
              <b-form-input
                type="text"
                v-model="form.name"
                required>
              </b-form-input>
          </b-form-group>

          <b-form-group
            label="Data da operação:"
            description="Exemplo: 21/02/2025 12:00">
            <masked-input
              type="text"
              class="form-control"
              v-model="form.date"
              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]"
              :guide="true"
              :keepCharPositions="true">
            </masked-input>
          </b-form-group>

          <b-form-group
            label="Local da operação:"
            description="Exemplo: Chácara Doce Gosto - Lavras MG">
              <b-form-input
                type="text"
                v-model="form.location"
                required>
              </b-form-input>
          </b-form-group>

          <b-form-group
            label="Descrição da operação:"
            description="Estas informações irão aparecer apenas na Loja.">
            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"></ckeditor>
          </b-form-group>

          <hr>

          <h3>Título e rodapé</h3>

          <b-form-group
            label="Título do ingresso:"
            description="Exemplo: TS Produções apresenta">
              <b-form-input
                type="text"
                v-model="form.title"
                required>
              </b-form-input>
          </b-form-group>

          <b-form-group
            label="Rodapé do ingresso:"
            description="Exemplo: Proibido venda de bebidas para menores de 18 anos.">
              <b-form-textarea id="textarea1"
                v-model="form.note"
                :rows="6"
                :max-rows="6">
              </b-form-textarea>
          </b-form-group>

          <hr>

          <h3>Organizador</h3>

          <b-form-group
            label="Nome do organizador:"
            description="Exemplo: Gabriel Spuri">
              <b-form-input
                type="text"
                v-model="form.organizer.name"
                required>
              </b-form-input>
          </b-form-group>

          <b-form-group
            label="Telefone principal do organizador:"
            description="Exemplo: (35) 99835-1273">
              <masked-input
                id="filter-date-begin"
                type="text"
                v-model="form.organizer.phones.main"
                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                :guide="true"
                :keepCharPositions="true">
              </masked-input>
          </b-form-group>

          <b-form-group
            label="Telefone secundário do organizador:"
            description="Exemplo: (35) 99835-1273">
              <masked-input
                type="text"
                v-model="form.organizer.phones.secondary"
                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                :guide="true"
                :keepCharPositions="true">
              </masked-input>
          </b-form-group>

          <hr>

          <h3>Tarifas da Loja</h3>

          <b-alert class="mb-0 mt-3" show variant="danger">Atenção: O sistema não validará os valores informados por você.</b-alert>

          <b-row>
            <b-col cols="12" md="9" lg="8" xl="5">
              <h5 class="mt-3">Boleto</h5>
              <b-form-group :description="getMinimumBilletRateAsLabel">
                <b-input-group prepend="R$" append="%">
                  <money required class="form-control" v-model="form.rates.billet.fixed" v-bind="money"></money>
                  <b-input-group-prepend is-text> <b>+</b> </b-input-group-prepend>
                  <money required class="form-control" v-model="form.rates.billet.percentage" v-bind="money"></money>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="9" lg="8" xl="5">
              <h5 class="mt-2">Cartão de crédito</h5>
              <b-form-group :description="getMinimumCardRateAsLabel">
                <b-input-group prepend="R$" append="%">
                  <money required class="form-control" v-model="form.rates.card.fixed" v-bind="money"></money>
                  <b-input-group-prepend is-text> <b>+</b> </b-input-group-prepend>
                  <money required class="form-control" v-model="form.rates.card.percentage" v-bind="money"></money>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="9" lg="8" xl="5">
              <h5 class="mt-2">Pix</h5>
              <b-form-group :description="getMinimumPixRateAsLabel">
                <b-input-group prepend="R$" append="%">
                  <money required class="form-control" v-model="form.rates.pix.fixed" v-bind="money"></money>
                  <b-input-group-prepend is-text> <b>+</b> </b-input-group-prepend>
                  <money required class="form-control" v-model="form.rates.pix.percentage" v-bind="money"></money>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <hr>
          
          <h3>Facebook Pixel</h3>

          <b-form-group
            class="mb-5"
            label="Pixel Id:"
            description="Exemplo: 554642443640076">
              <b-form-input
                type="text"
                v-model="form.facebook_pixel_id"
                required>
              </b-form-input>
          </b-form-group>

          <b-alert v-if="alert.type" show :variant="alert.type">{{ alert.message }}</b-alert>

          <b-button type="button" @click="submit" variant="primary" class="mb-4 mr-2" v-if="actionType === 'create'">
            Criar evento
          </b-button>

          <b-button type="button" @click="updateEvent" variant="primary" class="mb-4 mr-2" v-if="actionType === 'update'">
            Editar evento
          </b-button>

          <b-button type="button" @click="print" variant="info" class="mb-4">
            Imprimir exemplo
          </b-button>

        </b-col>

        <!-- Pre-visualização do Ingresso ou Ficha -->
        <b-col cols="12" md="4">
          <div style="position: sticky; top: 0;" class="py-2">
            <ticket
              :event-name="form.title"
              :event-image="form.image"
              :event-location="form.location"
              :event-date="dateUs"
              :event-note="form.note"
              :event-show-qrcode="form.show_qrcode"
              ticket-type-name="Lote Exemplo"
              ticket-type-value="2000"
              ticket-number="123"
              ticket-code="128ecf542a35ac5270a87dc740918404">
            </ticket>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="send-logo"
      ref="sendLogo"
      scrollable
      title="Escolha o logo"
      size="lg"
      hide-footer
    >
      <ImageUpload 
        @uploadDone="onUploadDone"
        :maxWidth="512"
        :maxHeight="512"
        :aspectRatio="4 / 3"
        chooseBtn="Escolher imagem"
        sendBtn="Enviar imagem"
      >

      </ImageUpload>    
    </b-modal>    

  </div>
</template>

<script>
import Upload from './Upload'
import Ticket from './Ticket'
import MaskedInput from 'vue-text-mask'
import {Money} from 'v-money'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import Modal from '@/components/Modal'
import ImageUpload from '@/components/ImageUpload'

export default {
  name: 'CreateEventV2',
  components: {
    Upload,
    Ticket,
    MaskedInput,
    Money,
    ckeditor: CKEditor.component,
    Modal,
    ImageUpload
  },
  data () {
    return {
      alert: {
        type: null,
        message: null
      },
      configs: {
        minimum_rates: {
          billet: {
            fixed: '',
            percentage: ''
          },
          card: {
            fixed: '',
            percentage: ''
          },
          pix: {
            fixed: '',
            percentage: ''
          }
        },
        default_rates: {
          billet: {
            fixed: '',
            percentage: ''
          },
          card: {
            fixed: '',
            percentage: ''
          },
          pix: {
            fixed: '',
            percentage: ''
          }
        }
      },
      originalForm: {},
      form: {
        name: '',
        title: '',
        date: '',
        location: '',
        description: '',
        note: null,
        image: null,
        show_qrcode: true,
        organizer: {
          name: '',
          phones: {
            main: '',
            secondary: ''
          }
        },
        rates: {
          billet: {
            fixed: '',
            percentage: ''
          },
          card: {
            fixed: '',
            percentage: ''
          },
          pix: {
            fixed: '',
            percentage: ''
          }
        },
        facebook_pixel_id: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      },
      editorConfig: {
        fontSize: {
          options: [
            { title: 'Tiny', model: '12px' },
            { title: 'Small', model: '13px' },
            'default',
            { title: 'Big', model: '20px' },
            { title: 'Huge', model: '23px' }
          ]
        },
        link: {
			    addTargetToExternalLinks: true
        }
      },
      editor: Editor
    }
  },
  methods: {
    submit () {
      let data = this.$_.cloneDeep(this.form)

      data.rates.billet.fixed = Math.round(data.rates.billet.fixed * 100)
      data.rates.billet.percentage = Math.round(data.rates.billet.percentage * 100)
      data.rates.card.fixed = Math.round(data.rates.card.fixed * 100)
      data.rates.card.percentage = Math.round(data.rates.card.percentage * 100)
      data.rates.pix.fixed = Math.round(data.rates.pix.fixed * 100)
      data.rates.pix.percentage = Math.round(data.rates.pix.percentage * 100)
      data.date = this.$moment(data.date, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:00')

      this.$http.post(process.env.VUE_APP_URL_APP + '/b/events', data).then(resp => {
        let msg = 'Evento cadastrado com sucesso'
        this.alert.type = 'success'
        this.alert.message = msg
        this.$router.push({ name: 'Events' })
      }, err => {
        this.alert.type = 'danger'
        this.alert.message = err.body.message
      })
    },
    onUploadDone (cbk) {
      if (!cbk) return false
      this.form.image = cbk.image
      this.$refs.sendLogo.hide()
    },
    print () {
      this.$session.flash
        .set('example', {
          name: this.form.title,
          date: this.form.date,
          image: this.form.image,
          show_qrcode: this.form.show_qrcode,
          location: this.form.location,
          note: this.form.note
        })

      let route = this.$router.resolve({
        name: 'PrintExample'
      })
      window.open(route.href, '_blank')
    },
    getEvent (eventId) {
      this.$http.get(process.env.VUE_APP_URL_APP + `/b/events/${eventId}`).then(res => {
        this.form = res.body

        this.form.date = this.$moment(this.form.date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')
        this.form.rates.billet.fixed /= 100
        this.form.rates.billet.percentage /= 100
        this.form.rates.card.fixed /= 100
        this.form.rates.card.percentage /= 100
        this.form.rates.pix.fixed /= 100
        this.form.rates.pix.percentage /= 100

        this.originalForm = this.$_.cloneDeep(this.form)
      }, err => {
        console.err(err)
      })
    },
    getConfigs () {
      this.$http.get(process.env.VUE_APP_URL_APP + '/b/admin/configs').then(res => {
        this.configs = res.body

        this.form.rates = this.$_.cloneDeep(this.configs.default_rates)
        this.form.rates.billet.fixed /= 100
        this.form.rates.billet.percentage /= 100
        this.form.rates.card.fixed /= 100
        this.form.rates.card.percentage /= 100
        this.form.rates.pix.fixed /= 100
        this.form.rates.pix.percentage /= 100
      }, err => {
        console.err(err)
      })
    },
    updateEvent () {
      let differences = function(newObj, oldObj, $_) {
        return $_.reduce(newObj, function (result, value, key) {
          if (!$_.isEqual(value, oldObj[key])) {
            if ($_.isArray(value)) {
              result[key] = []
              $_.forEach(value, function (innerObjFrom1, index) {
                if ($_.isNil(oldObj[key][index])) {
                  result[key].push(innerObjFrom1)
                } else {
                  let changes = differences(innerObjFrom1, oldObj[key][index], $_)
                  if (!$_.isEmpty(changes)) {
                    result[key].push(changes)
                  }
                }
              })
            } else if ($_.isObject(value)) {
              result[key] = differences(value, oldObj[key], $_)
            } else {
              result[key] = value
            }
          }
          return result
        }, {})
      }

      const edit = differences(this.form, this.originalForm, this.$_)

      if (this.$_.isEmpty(edit)) {
        return
      }

      if (edit.date) {
        edit.date = this.$moment(edit.date, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:00')
      }

      if (edit.rates && edit.rates.billet && edit.rates.billet.fixed) {
        edit.rates.billet.fixed = Math.round(edit.rates.billet.fixed * 100)
      }

      if (edit.rates && edit.rates.billet && edit.rates.billet.percentage) {
        edit.rates.billet.percentage = Math.round(edit.rates.billet.percentage * 100)
      }

      if (edit.rates && edit.rates.card && edit.rates.card.fixed) {
        edit.rates.card.fixed = Math.round(edit.rates.card.fixed * 100)
      }

      if (edit.rates && edit.rates.card && edit.rates.card.percentage) {
        edit.rates.card.percentage = Math.round(edit.rates.card.percentage * 100)
      }

      if (edit.rates && edit.rates.pix && edit.rates.pix.fixed) {
        edit.rates.pix.fixed = Math.round(edit.rates.pix.fixed * 100)
      }

      if (edit.rates && edit.rates.pix && edit.rates.pix.percentage) {
        edit.rates.pix.percentage = Math.round(edit.rates.pix.percentage * 100)
      }

      this.$http.put(process.env.VUE_APP_URL_APP + `/b/events/${this.$route.params.id}`, edit).then(resp => {
        let msg = 'Evento ' + this.form.name + ' editado com sucesso'
        this.alert.type = 'success'
        this.alert.message = msg
        this.originalForm = this.$_.cloneDeep(this.form)
        this.$router.push({ name: 'UpdateEvent', params: { id: this.$route.params.id } })
      }, err => {
        this.alert.type = 'danger'
        this.alert.message = err.body.message
        console.err(err)
      })
    },
    clearForm () {
      this.form = {
        name: '',
        title: '',
        date: '',
        location: '',
        note: null,
        image: null,
        show_qrcode: true,
        organizer: {
          name: '',
          phones: {
            main: '',
            secondary: ''
          }
        },
        rates: {
          billet: {
            fixed: '',
            percentage: ''
          },
          card: {
            fixed: '',
            percentage: ''
          },
          pix: {
            fixed: '',
            percentage: ''
          }
        }
      }
    },
    handleRoute () {
      if (this.$route.params.id !== undefined) {
        this.getConfigs()
        this.getEvent(this.$route.params.id)
      } else {
        this.clearForm()
        this.getConfigs()
      }
    }
  },
  watch: {
    '$route' () {
      this.handleRoute()
    }
  },
  created () {
    if (process.env.NODE_ENV === 'development') {
      this.form.name = 'Entrosa Bixo 2018'
      this.form.title = 'TS Produções e Eventos apresenta'
      this.form.date = '2019-02-21 15:00:00'
      this.form.image = 'https://bit.ly/2JKunW7'
      this.form.location = 'Salão São Sebastião Nepomuceno - MG'
      this.form.note = 'Proibido menores de 18 anos.\nOpen bar 5hrs.\n\nBoa festa ;)'
      this.form.organizer.name = 'Gabriel Spuri'
      this.form.show_qrcode = true
      this.form.organizer.phones.main = '(35) 99835-1273'
      this.form.organizer.phones.secondary = '(35) 99870-0887'
    }
    this.handleRoute()
    this.form.date = this.$moment().format('DD/MM/YYYY HH:mm')
  },
  computed: {
    dateUs () {
      return this.$moment(this.form.date, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:00')
    },
    actionType () {
      return this.$route.params.id !== undefined
        ? 'update'
        : 'create'
    },
    getMinimumBilletRateAsLabel () {
      let label = []

      if (this.configs && this.configs.minimum_rates && this.configs.minimum_rates.billet) {
        if (this.configs.minimum_rates.billet.fixed) {
          label.push(this.$options.filters.currency(this.configs.minimum_rates.billet.fixed))
        }
        if (this.configs.minimum_rates.billet.percentage) {
          label.push(this.$options.filters.percentage(this.configs.minimum_rates.billet.percentage))
        }
      }

      return 'Tarifa mínima recomendada: ' + label.join(' + ')
    },
    getMinimumCardRateAsLabel () {
      let label = []

      if (this.configs && this.configs.minimum_rates && this.configs.minimum_rates.card) {
        if (this.configs.minimum_rates.card.fixed) {
          label.push(this.$options.filters.currency(this.configs.minimum_rates.card.fixed))
        }
        if (this.configs.minimum_rates.card.percentage) {
          label.push(this.$options.filters.percentage(this.configs.minimum_rates.card.percentage))
        }
      }

      return 'Tarifa mínima recomendada: ' + label.join(' + ')
    },
    getMinimumPixRateAsLabel () {
      let label = []

      if (this.configs && this.configs.minimum_rates && this.configs.minimum_rates.pix) {
        if (this.configs.minimum_rates.pix.fixed) {
          label.push(this.$options.filters.currency(this.configs.minimum_rates.pix.fixed))
        }
        if (this.configs.minimum_rates.pix.percentage) {
          label.push(this.$options.filters.percentage(this.configs.minimum_rates.pix.percentage))
        }
      }

      return 'Tarifa mínima recomendada: ' + label.join(' + ')
    },
  }
}
</script>
